<template>
  <div class="ZugewieseneTage">


    <v-container fluid>
      <v-row>
        <div class="col-md-6">
          <div class="dateListing" v-if="dentistDays">
            <div class="listEntry" v-for="d in dentistDays" :key="d.id" :class="cssClass(d)">
              <div class="dateListingType">
                <DayType :type="d.type" ></DayType>
              </div>
              <div class="dateListingContent d-flex">
                {{ $helper.format(d.dateObject, 'dd.MM.yyyy (EEEE)') }}
                <v-spacer></v-spacer>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-6 stats">
          <h3>Auswertung</h3>
          <template v-if="dentistDays">
            <div>
              <v-chip label>{{dentistDays.length}} x</v-chip> Insgesamt zugewiesen
            </div>
            <div v-if="dentistDays.length>0">
              <v-divider class="my-1"></v-divider>
              <div class="my-1 type-normal"><v-chip small label>{{dayType_normal}} x</v-chip> an Wochentagen</div>
              <div class="my-1 type-weekend"><v-chip small label>{{dayType_weekend}} x</v-chip> an Wocheenden</div>
              <div class="my-1 type-special"><v-chip small label>{{dayType_special}} x</v-chip> an Feiertagen</div>
            </div>
          </template>
        </div>
      </v-row>
    </v-container>
    
  </div>
</template>

<script>
import DayType from './../DayType.vue';
import DayState from './../DayState.vue';
export default {
  components: { DayType, DayState },
  props: {
    year: { required:true },
    days: { required:true, type: Array },
    dentist: { required:true, type: Object },
  },
  data: () => ({
    loading:false,
  }),
  computed: {
    dentistDays() {
      return this.days.filter(elem => elem.dentist_id===this.dentist.id);
    },
    dayType_normal() { if(this.dentistDays) return this.dentistDays.filter(elem => elem.type==='normal').length; },
    dayType_weekend() { if(this.dentistDays) return this.dentistDays.filter(elem => elem.type==='weekend').length; },
    dayType_special() { if(this.dentistDays) return this.dentistDays.filter(elem => elem.type==='special').length; },
  },
  methods: {
    cssClass(data) {
      let result = {};
      if(data && data.type) {
        result['type-'+data.type] = true;
      }
      if(data && data.state) {
        result['state-'+data.state] = true;
      }
      return result;
    }
  }
}
</script>